export default __webpack_public_path__ + "static/media/doggo-light.26a13bc8.png";